// @core/api/endpoints/product/create_product_review.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateProductReviewRequest,
  ProductReviewResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Create product review
 * Submits a review for a product. Reviews are moderated before being visible in the marketplace.
 */
export async function CreateProductReview(
  product_id: string,
  data: CreateProductReviewRequest,
  options?: RequestOptions
): Promise<ProductReviewResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/reviews`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<ProductReviewResponse>(requestPath, data, requestOptions);
}
